export const SHOW_SELECTING_FREE_GIFT_POPUP = 'SHOW_SELECTING_FREE_GIFT_POPUP';

export const HIDE_SELECTING_FREE_GIFT_POPUP = 'HIDE_SELECTING_FREE_GIFT_POPUP';

export const SHOW_DELIVERY_PACKAGES_SECTION = 'SHOW_DELIVERY_PACKAGES_SECTION';

export const HIDE_DELIVERY_PACKAGES_SECTION = 'HIDE_DELIVERY_PACKAGES_SECTION';
